import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
interface Admin {
  id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  email: string;
  mobile: string;
  role: string;
  profile_img: string;
  roleName: string;
  customerId: string;
}
@Injectable({
  providedIn: 'root'
})
export class TokenService {
  decodedToken: any;
  token: any;
  constructor(
    public router: Router
  ) { }
  setToken(token: any) {
    localStorage.setItem('token', token);
  }
  refreshToken(token: any) {
    localStorage.setItem('refreshToken', token);
  }
  getToken() {
    const token = localStorage.getItem('token');
    this.token = token;
    return token;
  }
  deleteToken() {
    localStorage.removeItem('token');
  }
  setUser(user: Admin | null) {
    localStorage.setItem('user', JSON.stringify(user));
  }
  getUser(): any {
    const adminStr = localStorage.getItem('user');
    if (adminStr) {
      try {
        const admin: Admin = JSON.parse(adminStr);
        return admin;
      } catch (e) {
        console.error('Error parsing admin object:', e);
        localStorage.removeItem('user');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('token');
      }
    } else {
      localStorage.removeItem('user');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('token');
    }
  }
  decodeToken() {
    if (this.getToken()) {
      this.decodedToken = jwtDecode(this.token);
    }
  }
  getDecodeToken() {
    return jwtDecode(this.token);
  }
  getExpiryTime() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken.exp : null;
  }
  isTokenExpired(): boolean {
    const expiryTime: any = this.getExpiryTime();
    if (expiryTime) {
      return 1000 * expiryTime - new Date().getTime() < 5000;
    } else {
      return false;
    }
  }
  userLogout() {
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
}
